import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AgentHome } from "./components/AgentHome";
import { CustomerOrders } from "./components/CustomerOrders";
import { DemoNav, DemoView } from "./components/DemoNav";
import { OperationsAnalytics } from "./components/OperationsAnalytics";
import { OperationsBoard } from "./components/OperationsBoard";
import { AdminOrderDetail } from "./components/AdminOrderDetail";
import { ExclusiveBenefits } from "./components/ExclusiveBenefits";
import { OrderTracker } from "./components/OrderTracker";
import { MarketingReportPhilly } from "./pages/MarketingReportPhilly";
export function App() {
  const [view, setView] = useState<DemoView>("home");
  return <div className="min-h-screen w-full bg-neutral-50 font-heading" data-id="element-0" data-mp="2wifgpfyzpczr">
      <AnimatePresence mode="wait" data-id="element-1" data-mp="28tme50nv46w6">
        <motion.div key={view} initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.25
      }} data-id="element-2" data-mp="28sl4n0mhvsgk">
          {view === "home" && <AgentHome onOpenOrders={() => setView("orders")} data-id="element-3" data-mp="3mlawd43m29se" />}
          {view === "orders" && <CustomerOrders onHome={() => setView("home")} onTrack={() => setView("tracker")} onOpenReport={() => setView("report")} data-id="element-4" data-mp="3rcj6618urx63" />}
          {view === "report" && <MarketingReportPhilly onBack={() => setView("orders")} data-id="element-5" data-mp="2zm4xqkjlzd1t" />}
          {view === "tracker" && <OrderTracker onBack={() => setView("orders")} onHome={() => setView("home")} data-id="element-6" data-mp="33n6xd2hftr4b" />}
          {view === "ops-board" && <OperationsBoard onBack={() => setView("ops-analytics")} onHome={() => setView("home")} onOpenOrder={() => setView("ops-detail")} data-id="element-7" data-mp="3dlw9sfqkejd6" />}
          {view === "ops-detail" && <AdminOrderDetail onBack={() => setView("ops-board")} onHome={() => setView("home")} onOpenTracker={() => setView("tracker")} data-id="element-8" data-mp="swgi7ijiuqmh" />}
          {view === "ops-analytics" && <OperationsAnalytics onHome={() => setView("home")} onBoard={() => setView("ops-board")} data-id="element-9" data-mp="d3mil6oj2ni1" />}
          {view === "recruiting" && <ExclusiveBenefits onHome={() => setView("home")} data-id="element-10" data-mp="3gkuxpirvf992" />}
        </motion.div>
      </AnimatePresence>
      <DemoNav active={view} onNavigate={setView} data-id="element-11" data-mp="3bn30c98giuxh" />
    </div>;
}